export default function (ctrl) {
	return function () {
		if (ctrl.Form.$valid) {
			var params = {
				body: {
					password: btoa(ctrl.userData.password)
				}
			};
			ctrl.BaseService.createPromise('postForgottenPassword', params)
				.then(function () {
					ctrl.$state.go('forgotPassword.passwordSMS');
				})
				.catch(function () {
					ctrl.Form.password.$setValidity('unexpectedError', false);
				});
		}
	};
};
